import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "chat-actions" };
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = ["aria-label"];
import { computed, inject, ref } from "vue";
import { useAutoScrollControl } from "../composables/useAutoScrollControl";
// Components
import { Brain, Check, Copy } from "lucide-vue-next";
import { vTooltip } from "@/common/directives/tip-directive";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatMessageActions',
    props: {
        reasoning: {},
        debug: { type: Boolean }
    },
    emits: ["reasoning", "copy"],
    setup(__props, { emit: __emit }) {
        const i18n = inject("i18n");
        const props = __props;
        const emit = __emit;
        const { preventNextAutoScroll } = useAutoScrollControl();
        const reasoningMarkup = computed(() => {
            if (!props.reasoning) {
                return `<span class="reasoning-tooltip reasoning-tooltip--empty">${i18n.t("No reasoning provided")}</span>`;
            }
            // Format the reasoning with proper HTML structure
            return `<div class="reasoning-tooltip">
    <strong>${i18n.t("AI Reasoning")}:</strong>
    ${props.reasoning}
  </div>`;
        });
        const copied = ref(false);
        let copyTimeout = null;
        const handleCopy = () => {
            preventNextAutoScroll();
            copied.value = true;
            emit("copy");
            if (copyTimeout)
                clearTimeout(copyTimeout);
            copyTimeout = setTimeout(() => {
                preventNextAutoScroll();
                copied.value = false;
            }, 2000);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: "chat-actions__button",
                    "aria-label": _ctx.$t('View AI reasoning'),
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('reasoning')))
                }, [
                    _createVNode(_unref(Brain))
                ], 8, _hoisted_2)), [
                    [
                        _unref(vTooltip),
                        { content: reasoningMarkup.value, delay: { show: 300 } },
                        void 0,
                        {
                            white: true,
                            large: true,
                            se: true,
                            hidePoint: true,
                            touch: true,
                            html: true
                        }
                    ]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                    type: "button",
                    class: _normalizeClass(["chat-actions__button", { 'chat-actions__button--copied': copied.value }]),
                    "aria-label": copied.value ? _ctx.$t('Copied') : _ctx.$t('Copy'),
                    onClick: handleCopy
                }, [
                    (copied.value)
                        ? (_openBlock(), _createBlock(_unref(Check), { key: 0 }))
                        : (_openBlock(), _createBlock(_unref(Copy), { key: 1 }))
                ], 10, _hoisted_3)), [
                    [
                        _unref(vTooltip),
                        copied.value ? _ctx.$t('Copied') : _ctx.$t('Copy'),
                        void 0,
                        {
                            s: true,
                            hidePoint: true,
                            touch: true
                        }
                    ]
                ])
            ]));
        };
    }
});
